<!-- header -->
<mat-toolbar color="primary" class="header" [class.no-profile]="!(appState$ | async)?.isLoggedIn">
  <a mat-button class="application" [routerLink]="['/']">
    <!-- application logo -->
    <mat-icon class="application__logo" svgIcon="ref-portal:logo"></mat-icon>
    <!-- application name -->
    <span class="application__name">DMINT Data Portal</span>
  </a>

  <!-- application navbar -->

  <mat-action-list *ngIf="(appState$ | async)?.isReady" class="navs">
    <ng-container *ngIf="isUserPriviledge">
      <button
        *ngFor="let menu of menus; trackBy: trackMenuBy"
        mat-list-item
        [matMenuTriggerFor]="subMenu"
        class="navs__item"
        routerLinkActive="navs__item--active"
      >
        <mat-icon class="navs__item__icon" mat-list-icon svgIcon="ref-portal:{{ menu.id }}"></mat-icon>
        <span
          class="navs__item__title"
          mat-line
          [matBadge]="menu.id === 'notification' ? (pendingCounts$ | async)?.total : null"
          [matBadgeHidden]="menu.id !== 'notification' || ((pendingCounts$ | async)?.total ?? 0) <= 0"
          matBadgeColor="primary"
          matBadgeOverlap="false"
        >{{ menu.title }}</span>

        <!-- menus -->
        <mat-menu #subMenu="matMenu" class="navs__menu">
          <ng-container *ngFor="let subMenu of menu.submenus; trackBy: trackMenuBy; let isLast = last">
            <ng-container *ngIf="subMenu">
              <!-- menu item (with submenu) -->
              <button
                *ngIf="subMenu.submenus; else subMenuRef"
                routerLinkActive
                #rla="routerLinkActive"
                mat-menu-item
                [class.mat-menu-item--active]="rla.isActive"
                [matMenuTriggerFor]="subSubMenu"
                 #menuTrigger="matMenuTrigger"
              >
                {{ subMenu?.title }}

                <mat-menu #subSubMenu="matMenu" class="navs__submenu">
                  <ng-container
                    class="headers-buttons"
                    *ngFor="let subSubMenu of subMenu?.submenus; trackBy: trackMenuBy"
                  >
                  @if (subSubMenu?.path) {
                    <a
                      *ngIf="subSubMenu"
                      mat-menu-item
                      [disabled]="subRla.isActive"
                      [routerLink]="[subSubMenu.path]"
                      [queryParams]="subSubMenu?.params ?? []"
                      [state]="{ data: subSubMenu.privilege }"
                      routerLinkActive
                      #subRla="routerLinkActive"
                      (click)="menuTrigger.closeMenu()"
                    >
                      {{ subSubMenu.title }}
                    </a>

                  } @else {
                    <a
                      *ngIf="subSubMenu"
                      mat-menu-item
                      [disabled]="subRla.isActive"
                      [routerLink]="[menu.id, subSubMenu.businessLineCode, subSubMenu.id]"
                      [queryParams]="subSubMenu?.params ?? []"
                      [state]="{ data: subSubMenu.privilege }"
                      routerLinkActive
                      #subRla="routerLinkActive"
                      (click)="menuTrigger.closeMenu()"
                    >
                      {{ subSubMenu.title }}
                    </a>
                  }
                  </ng-container>
                </mat-menu>
              </button>

              <!-- menu item (without submenu) -->
              <ng-template #subMenuRef>
                <a
                  mat-menu-item
                  [disabled]="rla.isActive"
                  [routerLink]="[menu.id, subMenu.businessLineCode, subMenu?.id]"
                  [state]="{ data: subMenu.privilege }"
                  routerLinkActive
                  #rla="routerLinkActive"
                >
                  {{ subMenu?.title }}
                </a>
              </ng-template>
            </ng-container>
          </ng-container>
        </mat-menu>
      </button>
    </ng-container>

    <!-- RaMU portal link -->
    <a
      mat-list-item
      class="navs__item ramu-portal-link"
      [href]="ramuPortalUrl$ | async"
      target="_blank"
      rel="noopener noreferrer"
    >
      <mat-icon class="navs__item__icon" mat-list-icon>open_in_new</mat-icon>
      <span class="navs__item__title" mat-line>RaMU</span>
    </a>
  </mat-action-list>

  <!-- profile -->
  <div class="profile">
    <!-- Show loading spinner during Auth0 initialization -->
    <div *ngIf="(appState$ | async)?.isAuthLoading" class="auth-loading">
      <mat-spinner diameter="24"></mat-spinner>
    </div>
    <!-- Show login button only when Auth0 is ready and user is not logged in -->
    <button *ngIf="(appState$ | async)?.showLoginButton" mat-button (click)="loginWithRedirect()">Login</button>
    <!-- Show user profile when ready -->
    <div *ngIf="(appState$ | async)?.isReady">
      <span class="application__name">{{ username }}</span>
      <button class="profile-icon" mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon>manage_accounts</mat-icon>
        <mat-menu #menu="matMenu">
          <a mat-menu-item disabled>
            <mat-icon>settings</mat-icon>
            <span>Preferences</span>
          </a>
          <!-- <button mat-menu-item type="button" (click)="openChangePassPopup()">
            <mat-icon svgIcon="ref-portal:changePassword"></mat-icon>
            <span>Change Password</span>
          </button> -->
          <button mat-menu-item type="button" (click)="doSignOut()">
            <mat-icon>exit_to_app</mat-icon>
            <span>Sign out</span>
          </button>
        </mat-menu>
      </button>
    </div>
  </div>
</mat-toolbar>

<!-- body -->
<mat-sidenav-container class="body">
  <mat-sidenav-content>
    <!-- Show loading during Auth0 initialization -->
    <!-- <div *ngIf="(appState$ | async)?.isAuthLoading" class="auth-init-loader">
      <mat-spinner color="primary"></mat-spinner>
      <p>Initializing...</p>
    </div> -->

    <!-- logged body -->
    <div
      *ngIf="(appState$ | async)?.isLoggedIn && !(appState$ | async)?.isAuthLoading"
      [class.grid-column]="!(appState$ | async)?.hasPermissions"
    >
      @if (!(appState$ | async)?.hasPermissions && !(appState$ | async)?.dataLoaded) {
      <div class="permission-loader">
        <mat-spinner color="primary" value="50"></mat-spinner>
      </div>
      } @else { @if(isUserPriviledge){
      <router-outlet></router-outlet>
      } }
    </div>

    <!-- unlogged body - show when Auth0 is ready but user is not logged in
    <div *ngIf="!(appState$ | async)?.isLoggedIn && !(appState$ | async)?.isAuthLoading" class="unlogged-content">
      <div class="welcome-message">
        <h2>Welcome to DMINT Data Portal</h2>
        <p>Please login to access the application.</p>
      </div>
    </div>-->
  </mat-sidenav-content>
</mat-sidenav-container>
<!-- Mat spinner -->
<div *ngIf="(appState$ | async)?.isLoggedIn && !(appState$ | async)?.dataLoaded" class="route-change-loader">
  <div class="route-change-loader--bg"></div>
  <mat-progress-spinner color="primary" mode="indeterminate" value="50"></mat-progress-spinner>
</div>

<div *ngIf="(appState$ | async)?.isLoggedIn && (routeChangeLoader$ | async)" class="route-change-loader">
  <div class="route-change-loader--bg"></div>
  <mat-progress-spinner color="primary" mode="indeterminate" value="50"></mat-progress-spinner>
</div>

<!-- footer -->
<footer class="footer">Copyright © {{ currentYear }} MICHELIN. All rights reserved.</footer>
<ng-template let-dialogRef="dialogRef" #errorDialogRef>
  <div class="dialog-content">
    <mat-toolbar color="primary">
      <mat-icon>error</mat-icon>
      {{ isUserPriviledge ? 'Information' : 'Error' }}
    </mat-toolbar>
    <div class="message">
      @if (isUserPriviledge) {
      <h3>{{ (errorMessage$ | async)?.message }}</h3>
      } @else {
      <h3>No groups have been assigned to your account. Please contact the Admin.</h3>
      } @if (!isUserPriviledge) {
      <div class="actions">
        <button type="button" mat-flat-button color="accent" (click)="dialogRef.close(true)">Ok</button>
      </div>
      }
    </div>
  </div>
</ng-template>
